"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { useNavigation } from "@app/[locale]/(site)/navContext";
import { useMarket } from "@context/marketContext";
import { XIcon } from "@ngg/icons";
import type { Loop54Content } from "@server/utils/parseLoop/types";
import { Fragment } from "react";

import displayWithSuffix from "@/utils/displayWithSuffix";

export default function ActiveFilters({
  data,
  updateFilter,
}: {
  data: Loop54Content | undefined;
  updateFilter: (filter: any) => void;
}) {
  const t = useTranslate();
  const { locale } = useMarket().state.market;
  const { commerceNamePairs } = useNavigation().state;
  const hasFilters = data?.filter?.some(
    (facet) => facet.values && facet.values?.length > 0,
  );

  if (!data || !hasFilters) return null;

  const handleCheckbox = (attribute: string, value: string) => {
    const localFilter = [...data.filter];

    const filter = localFilter.map((facet) => {
      if (!facet.values) return facet;

      const values = [...facet.values];
      if (facet.values && facet.attribute === attribute) {
        values.splice(values.indexOf(value), 1);
        return { ...facet, values };
      }

      return facet;
    });

    updateFilter(filter);
  };

  const handleRange = (attribute: string) => {
    const localFilter = [...data.filter];
    const index = localFilter.findIndex(
      (filter) => filter.attribute === attribute,
    );
    if (index > -1) localFilter.splice(index, 1);
    updateFilter(localFilter);
  };

  return (
    <div className="mr-auto hidden flex-wrap items-center gap-2 py-4 lg:flex">
      {data.filter.map((facet) => {
        // if (facet?.type !== 'checkbox') return null;
        if (facet.type === "range" && facet.values?.length === 2) {
          return (
            <button
              key={facet.attribute}
              type="button"
              onClick={() => handleRange(facet.attribute)}
              className="flex items-center bg-grey-100 p-2 text-base text-black transition hover:bg-grey-150 focus-visible:outline focus-visible:outline-1 focus-visible:outline-black"
            >
              {displayWithSuffix({
                locale,
                values: facet.values,
                suffix: facet.extras?.suffix,
              })}
              <XIcon className="ml-1 text-base text-black" />
            </button>
          );
        }
        if (facet.type === "checkbox") {
          return (
            <Fragment key={facet.attribute}>
              {facet.values?.map((value) => (
                <button
                  key={value}
                  type="button"
                  onClick={() => handleCheckbox(facet.attribute, value)}
                  className="flex items-center bg-grey-100 p-2 text-base text-black transition hover:bg-grey-150 focus-visible:outline focus-visible:outline-1 focus-visible:outline-black"
                >
                  {t(value, { strict: true }) || commerceNamePairs?.[value] || value}
                  <XIcon className="ml-1 text-base text-black" />
                </button>
              ))}
            </Fragment>
          );
        }
        return null;
      })}
    </div>
  );
}
